module.exports = __webpack_public_path__ + "static/img/v35_05.f24c44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/v35_05.png
// module id = JyKQ
// module chunks = 3